import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'ghost' | 'subtle';
};

export const IconButton = forwardRef<HTMLButtonElement, Props>(
  ({ className, variant = 'ghost', ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'inline-flex h-9 w-9 items-center justify-center rounded-md text-[var(--color-foreground-muted)] transition-colors hover:bg-[var(--color-surface-muted)] hover:text-[var(--color-foreground)] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-[var(--color-foreground-muted)]',
          variant === 'subtle' &&
            'bg-[var(--color-surface-muted)] text-[var(--color-foreground)]',
          className,
        )}
        {...rest}
      />
    );
  },
);
IconButton.displayName = 'IconButton';
